import { Result, LoadingIndicator } from '@thesisedu/react'
import React from 'react'

export function AuthRedirecting() {
  return <Result icon={<LoadingIndicator />} title={'Authenticating...'} />
}
